//import { Repository } from './app_Repository';
//var repo = new Repository();
import { __tokenName } from './utils/vuexutils';



export default {

  //
  // SECURITY
  //
  setTokenWithExpiration(context, data) {
    //http://apassant.net/2012/01/16/timeout-for-html5-localstorage/
    // Remove token when storage is more than n hours
    var hours = data.TokenHours;
    var now = new Date().getTime();
    var tokenWithTime = context.getters.currentUserWithToken;
    data.time = now;
    localStorage.setItem(__tokenName, JSON.stringify(data));
    context.commit('SET_CURRENT_USER', data);

  },

  removeToken(context) {
    localStorage.removeItem(__tokenName);
  },


  loadPodruznice(context, force) {
    //var utils = new Utils(context.state.appModal)
    ////context.commit('SET_PODRUZNICE', [1]);
    //var self = this;
    //if (context.state.podruznice.length == 0 || force) {
    //  utils.$fetchDataPromise('/api/Base/GetPodruznice')
    //    .then(x => self.context.commit('SET_PODRUZNICE', x))
    //    .catch(x => {
    //      if (text.startsWith('server_msg')) {
    //        context.commit('SET_APP_MODAL_TEXT', this.$t(text));
    //      }
    //      else {
    //        context.commit('SET_APP_MODAL_TEXT', this.$t(text));
    //      }
    //      utils.$displayErrorModal(x)
    //    });
    //  //.catch(x => { utils.methods.$displayErrorModal(x) });
    //}
  },







  //$displayErrorModal(context, text) {
  //  //if (text.startsWith('server_msg')) {
  //  //  this.SET_APP_MODAL_TEXT(this.$t(text));
  //  //}
  //  //else {
  //  //  this.SET_APP_MODAL_TEXT(text);
  //  //}

  //  this.appModal.dialog = true;
  //},

  //displayError(context) {
  //  context.snack.appSnackRef.snackMe('top', 'center', { text: text, color: 'error' })

  //}

  //$displaySuccess(text) {
  //  this.snack.appSnackRef.snackMe('top', 'right', { text: text, color: 'success' })
  //}

  //$displayWarning(text) {
  //  this.snack.appSnackRef.snack('top', 'right', { text: text, color: 'warning' })
  //}

  //$displayInfo(text) {
  //  this.snack.appSnackRef.snackMe('top', 'center', { text: text, color: 'info' })
  //}

  //$displayPrimary(text) {
  //  this.snack.appSnackRef.snackMe('top', 'right', { text: text, color: 'purple' })
  //}


}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/app/app_actions.js